export default __webpack_public_path__ + "static/media/logo.40b7cd09.png";